export default class TypRezieService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("TypRezie.list").then(r => r.result);
  }

  save(item){
    return this.server("TypRezie.create", item);
  }

  update(item){
    return this.server("TypRezie.update", item); 
  }

  remove(item){
    return this.server("TypRezie.delete", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/TypRezieService.js